import { DateField as BoldDateField, DateFieldProps as BoldDateFieldProps, Omit } from 'bold-ui'
import { CypressProps } from 'types/cypress'

import { UseFieldProps, usePecField } from '../hooks/useField'
import { getFieldError } from '../util'

export type DateFieldProps = UseFieldProps<string> & Omit<BoldDateFieldProps, 'name'> & CypressProps

export function DateField({ dataTestId, ...restProps }: DateFieldProps) {
  // TODO (@RNG): Ajustar tipagem para não precisar de cast #29612
  const castProps = ({ parse, format, ...restProps } as unknown) as UseFieldProps<Date>
  const { input, meta, ...rest } = usePecField(castProps)

  return <BoldDateField error={getFieldError(meta)} data-testid={dataTestId} {...input} {...rest} />
}

export const parse = (value: Date): string => {
  if (!value) {
    return null
  }

  const year = ('000' + value.getFullYear()).slice(-4)
  const month = ('0' + (value.getMonth() + 1)).slice(-2)
  const day = ('0' + value.getDate()).slice(-2)

  return `${year}-${month}-${day}`
}

export const format = (value: string): Date => {
  if (!value) {
    return null
  }

  try {
    const dateParts = value.split('-')
    const date = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[2], 10))
    return date?.getTime() ? date : null
  } catch {
    return null
  }
}
